export default __webpack_public_path__ + "static/media/checkIcon.d8e62d34.svg";